import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/doi-tac/layout-client.tsx");
